import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class CedenteService {

  constructor(
    private http: HttpClient
  ) { }


  adicionar(data) {
    return this.http
      .post(urls.apiBase + '/Cedentes/Adicionar', data);
  }

  atualizar(data) {
    return this.http
      .put(urls.apiBase + '/Cedentes/Atualizar', data);
  }

  remover(id) {
    return this.http
      .delete(urls.apiBase + '/Cedentes/Remover?id=' + id);
  }

  obterPorContaId(id) {
    return this.http
      .get(urls.apiBase + '/Cedentes/ObterTodos?contaId=' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cedente/cedente.service.ts